// This file is generated by pnpm icons:generate. Do not edit.

import {createSVG} from '../TEMPLATE'

export const Hand = createSVG({
  elements: [
    {
      fill: 'currentColor',
      stroke: 'none',
      type: 'path',
      d: 'M17.625 4.5a2.6 2.6 0 0 0-1.125.254v-.629a2.625 2.625 0 0 0-5.123-.806A2.625 2.625 0 0 0 7.5 5.625v6l-.358-.575a2.625 2.625 0 0 0-4.556 2.608c1.5 3.166 2.712 5.412 4.098 6.815C8.085 21.894 9.675 22.5 12 22.5a8.26 8.26 0 0 0 8.25-8.25V7.125A2.625 2.625 0 0 0 17.625 4.5Zm1.125 9.75A6.76 6.76 0 0 1 12 21c-1.91 0-3.142-.457-4.25-1.58-1.24-1.257-2.382-3.389-3.822-6.428l-.028-.055a1.125 1.125 0 0 1 1.95-1.124l.012.021 1.75 2.813A.75.75 0 0 0 9 14.25V5.625a1.125 1.125 0 0 1 2.25 0v5.625a.75.75 0 0 0 1.5 0V4.125a1.125 1.125 0 0 1 2.25 0v7.125a.75.75 0 0 0 1.5 0V7.125a1.125 1.125 0 0 1 2.25 0Z',
      fillRule: 'evenodd',
    },
  ],
  viewBox: '0 0 24 24',
  glyph: 'Hand',
})
